module.exports = __webpack_public_path__ + "img/check-mark.e7b6e093.png";